
<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section">
    <form [formGroup]="imagesEditForm">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="images-widget-name">
      </mat-form-field>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <mat-form-field appearance="outline" class="w-100 ">
            <mat-label>{{'pass.title' | translate}}</mat-label>
            <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}" data-nar="images-widget-title">
          </mat-form-field>
        </div>
        <div class="ps-2 flex-grow-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.subtitle' | translate}}</mat-label>
            <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}" data-nar="images-widget-subtitle">
          </mat-form-field>
        </div>
      </div>

      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title style="color:#595c5f;">
            <mat-icon class="material-symbols-outlined">dashboard</mat-icon> <span class="px-2">Layout</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="layout-grid" role="radiogroup" aria-label="Layout auswählen">

          @for (lay of layoutTypes; track trackByLayout($index, lay)) {
            <button type="button"
              class="layout-image d-flex flex-column align-items-center"
              [class.active]="imagesEditForm.get('layout')?.value === lay.value"
              (click)="selectLayout(lay.value)"
              (keydown.enter)="selectLayout(lay.value)"
              (keydown.space)="selectLayout(lay.value); $event.preventDefault()" role="radio"
              [attr.aria-checked]="imagesEditForm.get('layout')?.value === lay.value"
              [attr.aria-label]="lay.translate" [disabled]="translationModeOriginal || data.translateMode">
              <img class="img-fluid" [src]="'./../../assets/img/widget-graphics/' + lay.value + '.png'" alt="" style="width: 100px;">
              <div class="mt-1 layout-label">{{ lay.translate | translate }}</div>
            </button>
          }
        </div>
        @if (layoutBad) {
          <mat-card class="layout-error px-3 py-2 my-2"> {{'pass.layout_error' | translate}} </mat-card>
        }

        <mat-card class="layout-info px-3 py-2">
          @if (imagesEditForm.get('layout')?.value === 'horizontal') {
            <div>{{'pass.layout_info.horizontal' | translate}}</div>
          }
          @if (imagesEditForm.get('layout')?.value === 'twoVertical') {
            <div>{{'pass.layout_info.twoVertical' | translate}}</div>
          }
          @if (imagesEditForm.get('layout')?.value === 'twoHorizontal') {
            <div>{{'pass.layout_info.twoHorizontal' | translate}}</div>
          }
          @if (imagesEditForm.get('layout')?.value === 'threeLayout1') {
            <div>{{'pass.layout_info.threeLayout1' | translate}}</div>
          }
          @if (imagesEditForm.get('layout')?.value === 'threeLayout2') {
            <div>{{'pass.layout_info.threeLayout2' | translate}}</div>
          }
          @if (imagesEditForm.get('layout')?.value === 'fourLayout1') {
            <div>{{'pass.layout_info.fourLayout1' | translate}}</div>
          }
          @if (imagesEditForm.get('layout')?.value === 'fourLayout2') {
            <div>{{'pass.layout_info.fourLayout2' | translate}}</div>
          }
          @if (imagesEditForm.get('layout')?.value === 'fourLayout3') {
            <div>{{'pass.layout_info.fourLayout3' | translate}}</div>
          }
        </mat-card>
      </mat-expansion-panel>

      <mat-expansion-panel class="image-source-configuration my-2" expanded>
          <mat-expansion-panel-header>
            <mat-panel-title style="color:#595c5f;">
              <mat-icon class="material-symbols-outlined">source</mat-icon>
              <span class="px-2">{{ 'pass.widgets.source' | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="image-source-content">
      <mat-form-field appearance="outline" class="w-100 image-source-selector">
        <mat-label>{{ 'pass.widgets.source' | translate }}</mat-label>
        <mat-select [value]="selectedImageSourceTab" (selectionChange)="selectImageSource($event.value)" data-nar="images-widget-source">
          <mat-option [value]="0" [disabled]="isArrayMode"><mat-icon>image</mat-icon>{{ 'pass.widgets.manualSource' | translate }}</mat-option>
          <mat-option [value]="1"><mat-icon>account_tree</mat-icon>{{ 'pass.widgets.dataStructureSource' | translate }}</mat-option>
          <mat-option [value]="2"><mat-icon>link</mat-icon>{{ 'pass.widgets.mediaUrlSource' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      @if (selectedImageSourceTab === 0) {
      <div class="image-source-section">

            @if (!imagesEditForm.value.images|| imagesEditForm.value?.images?.length == 0) {
              <div [app-drag-file-browse-ui] = "dragFileData" (returnChanges)="returnChangesDragFileBrowseUI($event)"></div>
            }

            @if (imagesEditForm.value?.images?.length > 0) {
              <div appDragAndDrop (files)="filesDropped($event)">
                <mat-hint>{{'dragDrop-files' | translate}}</mat-hint>
                <div class="d-flex my-3">
                  <button mat-button class="secondary-gray-button me-2" (click)="triggerFileInput()" [disabled]="translationModeOriginal || data.translateMode">
                    <mat-icon>add_photo_alternate</mat-icon> {{'pass.browse' | translate}}
                  </button>
                  <input #fileInput type="file" id="myfile" name="myfile" style="display: none;" accept=".jpg, .jpeg, .png, .webp" (change)="readURL($event)">
                  <button mat-button class="secondary-gray-button ms-2" (click)="openMediaURL();" [disabled]="translationModeOriginal || data.translateMode">
                    <mat-icon>add_link</mat-icon> URL
                  </button>
                  <button mat-button class="secondary-gray-button ms-2" (click)="browserFromMediaFolder();" [disabled]="translationModeOriginal || data.translateMode || contextLicenseFree">
                    <mat-icon>perm_media</mat-icon> {{'topNavbar.media' | translate}}
                  </button>
                </div>
                <mat-divider class="mb-2"></mat-divider>
                <div class="mt-2 imageContainer">
                  <div class="p-2" cdkDropList [cdkDropListData]="imagesRef" cdkDropListOrientation="vertical" (cdkDropListDropped)="onReorder($event)">
                    @for (im of imagesEditForm.value.images; track im; let index = $index) {
                      <mat-card cdkDrag aria-label="Drag to reorder" class="my-1">
                        <input matInput type="text" formControlName="images" value="{{im.url}}" style="display:none">
                        <div class="d-flex justify-content-between image-wrapper position-relative" style="width: 100%; height: 75px; overflow: hidden;">
                          @if (!url[im.url] && !data.translateMode) {
                            <img [src]="im.url" class="rounded"  style="object-fit: cover; height: 100%; width:18%;"
                              onerror="this.src='./../../assets/img/default.jpg'" alt="{{im.url}}" >
                            }
                            @if (url[im.url] && !data.translateMode) {
                              <img [src]="url[im.url]"  class="rounded" style="object-fit: cover; height: 100%; width:18%;"
                                onerror="this.src='./../../assets/img/default.jpg'" alt="{{im.url}}">
                              }
                              @if (url[im.id] && data.translateMode && !translationModeOriginal) {
                                <img [src]="url[im.id]"  class="rounded" style="object-fit: cover; height: 100%; width:18%;"
                                  onerror="this.src='./../../assets/img/default.jpg'" alt="{{im.url}}">
                                }
                                @if (url[im.id] && translationModeOriginal) {
                                  <img [src]="url[im.id]" class="rounded"  style="object-fit: cover; height: 100%; width:18%;"
                                    onerror="this.src='./../../assets/img/default.jpg'" alt="{{im.url}}" >
                                  }
                                  <div class="py-1" style="width:80%">
                                    <div matTooltip="{{im.url}}" matTooltipShowDelay="2000" style="font-size: 12px;overflow: hidden; text-overflow: ellipsis;max-width: 95%;white-space: nowrap;">{{im.url}}</div>
                                    <div class="d-flex justify-content-start">
                                      <button mat-icon-button style="background-color: #fff; color: var(--warmOrange);" (click)="editImg(im, index)" [disabled]="translationModeOriginal" data-nar="images-widget-edit-image" [style.color]="translationModeOriginal ? '#b8b8b8' : 'var(--warmOrange)'">
                                        <span class="material-symbols-outlined">edit</span>
                                      </button>
                                      <button mat-icon-button style="background-color: #fff; color: var(--warmOrange);" (click)="deleteImg(im.url, index)" [disabled]="translationModeOriginal || data.translateMode" [style.color]="(translationModeOriginal || data.translateMode) ? '#b8b8b8' : 'var(--warmOrange)'">
                                        <span class="material-symbols-outlined">delete</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </mat-card>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
            }

      @if (selectedImageSourceTab === 1) {
          <div class="image-source-section">
                    <p class="text-muted mb-3">{{ 'pass.widgets.repeatImagesHelp' | translate }}</p>
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{ 'pass.widgets.arrayKeyPath' | translate }}</mat-label>
                      <input formControlName="keyPath" type="text" matInput data-nar="images-widget-key-path">
                      @if (arrayKeyPaths.length && !data.translateMode) {
                        <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="arrayPathMenu"
                          [attr.aria-label]="'pass.widgets.chooseArrayPath' | translate">
                          <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
                        </button>
                      }
                      <mat-hint>{{ 'pass.widgets.arrayKeyPathHint' | translate }}</mat-hint>
                    </mat-form-field>
                    <mat-menu #arrayPathMenu="matMenu">
                      @for (path of arrayKeyPaths; track path) {
                        <button mat-menu-item type="button" style="width: 320px; max-width: 100%;" [matTooltip]="path"
                          [attr.aria-label]="path" (click)="selectArrayKeyPath(path)">
                          <span class="d-block text-truncate">{{ displayArrayKeyPath(path) }}</span>
                        </button>
                      }
                    </mat-menu>

                    @if (isArrayMode) {
                      <div class="mt-3">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>{{ 'pass.url' | translate }}</mat-label>
                          <input matInput type="text" [value]="getDynamicImageField('url')"
                            (input)="setDynamicImageField('url', $any($event.target).value)"
                            placeholder="url" data-nar="images-widget-dynamic-url">
                          @if (arrayItemKeyPaths.length) {
                            <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="dynamicImageUrlMenu">
                              <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
                            </button>
                          }
                          <mat-hint>{{ 'pass.widgets.arrayItemKeyPathHint' | translate }}</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>{{ 'pass.link-URL' | translate }}</mat-label>
                          <input matInput type="text" [value]="getDynamicImageField('linkURL')"
                            (input)="setDynamicImageField('linkURL', $any($event.target).value)"
                            placeholder="url" data-nar="images-widget-dynamic-link-url">
                          @if (arrayItemKeyPaths.length) {
                            <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="dynamicImageLinkMenu">
                              <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
                            </button>
                          }
                          <mat-hint>{{ 'pass.widgets.arrayItemKeyPathHint' | translate }}</mat-hint>
                        </mat-form-field>

                        <mat-menu #dynamicImageUrlMenu="matMenu">
                          @for (path of arrayItemKeyPaths; track path) {
                            <button mat-menu-item type="button" [matTooltip]="path" (click)="setDynamicImageField('url', path)">
                              <span class="d-block text-truncate">{{path}}</span>
                            </button>
                          }
                        </mat-menu>
                        <mat-menu #dynamicImageLinkMenu="matMenu">
                          @for (path of arrayItemKeyPaths; track path) {
                            <button mat-menu-item type="button" [matTooltip]="path" (click)="setDynamicImageField('linkURL', path)">
                              <span class="d-block text-truncate">{{path}}</span>
                            </button>
                          }
                        </mat-menu>
                      </div>
                    }
          </div>
      }

      @if (selectedImageSourceTab === 2) {
          <div class="image-source-section">
            <p class="text-muted mb-3">{{ 'pass.widgets.dynamicMediaUrlHint' | translate }}</p>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.mediaURL' | translate}}</mat-label>
              <input formControlName="mediaURL" type="url" matInput placeholder="{{'pass.mediaURL' | translate}}">
            </mat-form-field>
          </div>
      }

          </div>
      </mat-expansion-panel>

              <div [app-widget-styling] = "{'form':imagesEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesStyle($event)"></div>

            </form>
          </section>

          <div [app-widget-edit-filters] = "{'form': imagesEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>

        </div>

